import customerAPI from '@/data/customers'

const state = {
  // = data
  all: [],
}

const getters = {
  // = computed properties
  // allTeam(state, getters, rootState) {
  //   console.log(rootState.team);
  //   return state.team;
  // },
  allCustomers: state => state.all,
  // getService: (state) => slug => {
  //   console.log(slug);
  //   state.team.filter(service => service.slug === slug),
  // },
  // getCustomerBySlug: state => slug =>
  //   state.all.filter(service => service.slug === slug)[0],
}

const actions = {
  // = Methods
  fetchCustomers({ commit }) {
    return new Promise(resolve => {
      // make the call
      customerAPI.getCustomers(customers => {
        commit('setCustomers', customers)
        resolve()
      })
    })
  },
}

const mutations = {
  // = responsible for setting and updating the state
  setCustomers(state, customers) {
    // update team
    state.all = customers
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
